import script from "./OffsideMiscList.vue?vue&type=script&setup=true&lang=ts"
export * from "./OffsideMiscList.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__